import {
    requestComments,
    receiveComments,
    clearComments,
} from "./actions";

import CommentRepository from "../_repositories/commentRepository";
import Comment from "../_data/models/Comment";
import {plainToClass} from "class-transformer";
import Meta from "../_data/models/Meta";
import * as _ from "lodash";
import {addDataAction, updateDataAction} from "../_data/actions";
import {ResourceType} from "../_helpers/data";

export function fetchCommentsByStyle(id: number, page: number, perPage: number = 5) {
    return (dispatch, getState) => {
        dispatch(requestComments());
        CommentRepository.getByStyleId2(id, page, perPage).then(data => {            
            const {comments, meta} = data;
            
            let users = _.map(comments, (each) => {
                return each['user'];
            });    

            dispatch(addDataAction({
                resource: ResourceType.user,
                data: users
            }));

            return dispatch(receiveComments({
                meta: plainToClass(Meta, meta),
                comments: plainToClass(Comment, comments)
            }));
        });
    }
}



// WEBPACK FOOTER //
// ./app/client/comment/middlewares.ts